/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="94.47"
        viewBox="0 0 95.59 94.47"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M4.38 57.15a7.57 7.57 0 0 0 1.13.48 8.69 8.69 0 0 0 2.29.44 1.25 1.25 0 1 0 .12-2.49 6 6 0 0 1-1.61-.32l-.28-.1-.23-.1-.17-.06h-.06a1.25 1.25 0 1 0-1.19 2.19ZM13.59 55a11 11 0 0 0 1.32-3.1 1.25 1.25 0 0 0-2.41-.65 8.55 8.55 0 0 1-1 2.42A1.25 1.25 0 0 0 13.59 55Zm1.91-8.71c.14-1 .3-2 .49-2.88a1.27 1.27 0 0 0-2.49-.51c-.2 1-.37 2-.52 3a1.252 1.252 0 0 0 2.48.35Zm2-8a18.35 18.35 0 0 1 1.24-2.51 1.25 1.25 0 0 0-2.13-1.3 18.71 18.71 0 0 0-1.42 2.87 1.25 1.25 0 0 0 .65 1.65 1.24 1.24 0 0 0 1.66-.66Zm4.64-5.82A5.88 5.88 0 0 1 24.5 32a1.25 1.25 0 0 0-.05-2.5 8.22 8.22 0 0 0-3.43.8 1.24 1.24 0 0 0-.6 1.66 1.26 1.26 0 0 0 1.68.56Zm7.06.71a18.88 18.88 0 0 1 2.39 1.49 1.25 1.25 0 1 0 1.47-2A22.81 22.81 0 0 0 30.32 31a1.252 1.252 0 1 0-1.16 2.22Zm6.41 5c.65.66 1.31 1.38 2 2.15a1.251 1.251 0 0 0 1.89-1.64c-.7-.81-1.4-1.56-2.09-2.26a1.25 1.25 0 1 0-1.78 1.75Zm5.66 6.33a27.58 27.58 0 0 0 2.23 2.23 1.25 1.25 0 1 0 1.6-1.91 24.3 24.3 0 0 1-2.06-2 1.252 1.252 0 1 0-1.82 1.72Zm8.23 4.55a6.33 6.33 0 0 0 3.36-1.65 1.254 1.254 0 0 0-1.67-1.87 4 4 0 0 1-1.81 1h-.2a1.27 1.27 0 1 0 .32 2.52Zm6.82-6.56c.46-.91.94-1.75 1.42-2.53a1.26 1.26 0 0 0-.4-1.72 1.27 1.27 0 0 0-1.73.4c-.51.84-1 1.74-1.52 2.7a1.255 1.255 0 1 0 2.23 1.15Zm4.61-6.64a12 12 0 0 1 2.13-1.68A1.282 1.282 0 0 0 61.71 32a15.11 15.11 0 0 0-2.57 2 1.25 1.25 0 1 0 1.75 1.78Zm6.57-2.8a7.84 7.84 0 0 1 2.48.72 1.25 1.25 0 0 0 1.07-2.26 10.27 10.27 0 0 0-3.29-1 1.277 1.277 0 0 0-.26 2.54Zm6.44 3.83a18.6 18.6 0 0 1 1.71 2.24 1.25 1.25 0 0 0 2.09-1.37 21.34 21.34 0 0 0-1.93-2.53 1.25 1.25 0 1 0-1.87 1.66Zm4 6.89a13.38 13.38 0 0 1 .63 2.68 1.25 1.25 0 1 0 2.48-.31 15.78 15.78 0 0 0-.74-3.16 1.25 1.25 0 0 0-2.37.79Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M0 1.25v79.49a1.26 1.26 0 0 0 .8 1.17l31.32 12.14a1.3 1.3 0 0 0 .91 0l30-11.63 30.87 12a1.24 1.24 0 0 0 1.7-1.16V13.73a1.24 1.24 0 0 0-.79-1.16L63.5.43a1.27 1.27 0 0 0-.9 0L32.58 12 1.7 0A1.25 1.25 0 0 0 0 1.25Zm33 13.3L63 2.93l30.07 11.66v76.8L63.5 79.92a1.27 1.27 0 0 0-.9 0l-30 11.62L2.5 79.89V3.07l29.63 11.48a1.27 1.27 0 0 0 .9 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M72.98 49.22a1.23 1.23 0 0 1 1.66-.09l.11.09 12 12A1.25 1.25 0 0 1 85.04 63l-.1-.09-12-12a1.25 1.25 0 0 1 .04-1.69Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M84.94 49.22a1.25 1.25 0 0 1 1.77 0 1.27 1.27 0 0 1 .09 1.67l-.09.1-12 12a1.25 1.25 0 0 1-1.77 0 1.23 1.23 0 0 1-.09-1.66l.09-.11ZM32.58 12.14a1.24 1.24 0 0 1 1.24 1.12v79.62a1.25 1.25 0 0 1-2.49.13V13.39a1.24 1.24 0 0 1 1.25-1.25ZM63.02.34a1.26 1.26 0 0 1 1.24 1.13v79.61a1.252 1.252 0 0 1-2.5.13V1.59A1.25 1.25 0 0 1 63.02.34Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperMapIcon';

export default Icon;
